export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 100;

export function paginationParams(page = DEFAULT_PAGE, limit = DEFAULT_LIMIT): string {
  return `page=${page}&limit=${limit}`;
}
